module.exports = "<div class=\"toast-class\" toastContainer></div>\n"